import { render, staticRenderFns } from "./OntBrief.vue?vue&type=template&id=33387698&"
import script from "./OntBrief.vue?vue&type=script&lang=js&"
export * from "./OntBrief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports